"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apricotPalette = void 0;
var themeCreator_1 = __importDefault(require("./themeCreator"));
exports.apricotPalette = {
    component: {
        answerSelectedColor: 'rgb(26, 155, 219)',
        answerUnselectedColor: 'rgb(225, 225, 225)',
        continueButtonColor: 'rgb(255, 151, 26)',
        continueButtonHoverColor: 'rgb(249, 137, 10)',
        backButtonColor: 'rgb(237, 237, 237)',
        backButtonHoverColor: 'rgb(223, 223, 223)',
        progressBarFilledColor: 'rgb(0, 202, 165)',
        progressBarUnfilledColor: 'rgb(247, 247, 247)',
        scrollIndicatorColor: 'rgb(79, 79, 79)',
    },
    background: {
        answerBackgroundColor: 'rgb(255, 255, 255)',
        secondaryBackgroundColor: 'rgb(247, 247, 247)',
        widgetBackgroundColor: 'rgb(255,255,255)',
    },
    text: {
        primaryTextColor: 'rgb(0, 0, 0)',
        continueButtonTextColor: 'rgb(255, 255, 255)',
        secondaryTextColor: 'rgb(79, 79, 79)',
    },
    status: {
        disabled: 'rgb(134, 134, 134)',
        error: 'rgb(249, 98, 78)',
    },
};
var apricotTheme = (0, themeCreator_1.default)(exports.apricotPalette);
exports.default = apricotTheme;
//# sourceMappingURL=apricotTheme.js.map